<script lang="ts">
	import type { MeetingMinute } from '$lib/types/meeting';
	import MeetingCard from './MeetingCard.svelte';

	export let meetings: MeetingMinute[];
	export let title = '';
	export let showYear = false;
	export let emptyMessage = 'No meetings found.';
</script>

{#if title}
	<h2 class="mb-6 text-2xl font-bold text-gray-900 dark:text-white">{title}</h2>
{/if}

{#if meetings.length > 0}
	<div class="grid gap-6">
		{#each meetings as meeting (meeting.slug)}
			<MeetingCard {meeting} {showYear} />
		{/each}
	</div>
{:else}
	<div class="py-12 text-center">
		<div class="text-lg text-gray-500 dark:text-gray-400">
			{emptyMessage}
		</div>
	</div>
{/if}
